// extracted by mini-css-extract-plugin
export default {"loaded_icon_outer":"AppCellIcon_loaded_icon_outer__DnpfQ","loaded_icon_inner":"AppCellIcon_loaded_icon_inner__2+N9x"};